// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TopBar-base__FfIzf{position:sticky;top:var(--size-0);right:var(--size-0);left:var(--size-0);z-index:var(--z-index-app-frame);display:flex;flex-direction:column;background-color:var(--surface-level-first)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "TopBar-base__FfIzf"
};
export default ___CSS_LOADER_EXPORT___;
